import React from 'react';
import { LOGO_URL, footerLinks, announcement } from '../mock';
import { Instagram, Youtube, Facebook, Mail, Phone } from 'lucide-react';
import { toast } from '../hooks/use-toast';

export default function Footer() {
  const [email, setEmail] = React.useState('');
  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    toast({ title: 'You’re in.', description: `We’ll keep you updated at ${email}.` });
    setEmail('');
  };
  return (
    <footer className="mt-24 border-t border-black/5 dark:border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
        <div className="grid lg:grid-cols-2 gap-10 items-center pb-10 border-b border-black/5 dark:border-white/5">
          <div>
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              <span className="tag-dot" /> Newsletter
            </div>
            <h3 className="font-grotesk mt-3 text-3xl sm:text-4xl tracking-[-0.02em] font-medium max-w-lg">Get 10% off your first bottle.</h3>
            <p className="mt-2 text-neutral-500 max-w-md">Recovery tips, sleep science and early drops — straight to your inbox. No spam.</p>
          </div>
          <form onSubmit={submit} className="flex items-center gap-2 bg-neutral-100 dark:bg-neutral-900 rounded-full p-1.5 border border-black/5 dark:border-white/5 lg:justify-self-end w-full max-w-md">
            <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" type="email" className="flex-1 bg-transparent outline-none px-4 py-2 text-sm placeholder:text-neutral-500" />
            <button className="px-5 py-2.5 rounded-full bg-[color:var(--cv-teal)] text-white text-sm font-semibold hover:bg-[color:var(--cv-teal-dark)] transition">Subscribe</button>
          </form>
        </div>

        <div className="mt-12 grid md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <img src={LOGO_URL} alt="" className="h-10 w-10 rounded-full object-cover" />
              <div className="font-grotesk tracking-[0.22em] text-sm font-bold">COREVIVE</div>
            </div>
            <p className="mt-4 text-neutral-500 text-sm max-w-xs">Made in India. Formulated for the athlete, the founder, and everyone chasing better sleep.</p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" aria-label="Instagram" className="h-9 w-9 rounded-full border border-current/10 inline-flex items-center justify-center hover:bg-[color:var(--cv-teal)] hover:text-white hover:border-transparent transition"><Instagram size={14} /></a>
              <a href="#" aria-label="YouTube" className="h-9 w-9 rounded-full border border-current/10 inline-flex items-center justify-center hover:bg-[color:var(--cv-teal)] hover:text-white hover:border-transparent transition"><Youtube size={14} /></a>
              <a href="#" aria-label="Facebook" className="h-9 w-9 rounded-full border border-current/10 inline-flex items-center justify-center hover:bg-[color:var(--cv-teal)] hover:text-white hover:border-transparent transition"><Facebook size={14} /></a>
            </div>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500 mb-3">Shop</div>
            <ul className="space-y-2 text-sm">
              {footerLinks.shop.map((l) => <li key={l}><a href="#" className="hover:text-teal transition-colors">{l}</a></li>)}
            </ul>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500 mb-3">Customer Care</div>
            <ul className="space-y-2 text-sm">
              {footerLinks.care.map((l) => <li key={l}><a href="#" className="hover:text-teal transition-colors">{l}</a></li>)}
            </ul>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500 mb-3">Contact</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2"><Phone size={14} className="text-teal" /> {announcement.contactPhone}</li>
              <li className="flex items-center gap-2"><Mail size={14} className="text-teal" /> {announcement.contactEmail}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-black/5 dark:border-white/5 flex flex-wrap items-center justify-between gap-4 text-[12px] text-neutral-500">
          <div>© {new Date().getFullYear()} Corevive. All rights reserved. Made in India.</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-teal">Refund Policy</a>
            <a href="#" className="hover:text-teal">Privacy Policy</a>
            <a href="#" className="hover:text-teal">Terms of Service</a>
            <a href="#" className="hover:text-teal">Shipping Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
